/* Kiomia - quando si cambia confezione, la galleria va sulla foto di quella variante.

   Il buco era qui: km-pdp.js, scegliendo una variante, aggiornava prezzo,
   identificativo e disponibilita, ma la galleria non la guardava mai. Quindi si
   poteva caricare su Shopify la foto dei cinque filtri sulla variante Scorta
   Anno, come e stato fatto, e non la vedeva nessuno: restava sempre in mostra
   la prima immagine del prodotto.

   Sta in un file suo e non dentro km-pdp.js per non rimettere le mani in un file
   che fa gia sei cose diverse. Si aggancia dopo, sugli stessi radio.

   Come trova la foto: nel JSON delle varianti che la sezione stampa gia in
   pagina c'e featured_media.position, cioe il posto che quella foto occupa nella
   galleria del prodotto. Le posizioni di Shopify partono da 1, i riquadri da 0. */
(function () {
  function nastro() { return document.querySelector('.km-pdp__gal .km-pdp__stage'); }

  function vaiA(i) {
    var n = nastro();
    if (!n) return;
    var riquadri = n.querySelectorAll('.km-pdp__slide');
    if (i < 0 || i >= riquadri.length) return;
    /* Se km-galleria.js e attivo usiamo il suo scorrimento, cosi si aggiornano
       anche i pallini. Se no facciamo scorrere noi, fermandoci al massimo
       possibile: sul telefono l'ultima foto sta a destra e chiedere di piu
       vorrebbe dire farsi riportare indietro dall'aggancio. */
    if (typeof n.kmVaiA === 'function') { n.kmVaiA(i); return; }
    var passo = riquadri.length > 1 ? (riquadri[1].offsetLeft - riquadri[0].offsetLeft) : n.clientWidth;
    var meta = Math.min(i * passo, n.scrollWidth - n.clientWidth);
    n.scrollTo({ left: meta, behavior: 'smooth' });
  }

  function aggancia(scheda) {
    if (!scheda || scheda.getAttribute('data-km-vfoto')) return;
    var vj = scheda.querySelector('[data-km-varianti]');
    if (!vj) return;
    var varianti;
    try { varianti = JSON.parse(vj.textContent || '[]'); } catch (e) { return; }
    if (!varianti.length) return;
    scheda.setAttribute('data-km-vfoto', '1');

    var gruppi = scheda.querySelectorAll('[data-km-opt-group]');

    function scelta() {
      var scelte = [];
      for (var g = 0; g < gruppi.length; g++) {
        var r = gruppi[g].querySelector('[data-km-opt]:checked');
        if (r) scelte.push(r.value);
      }
      for (var i = 0; i < varianti.length; i++) {
        var ok = true;
        for (var k = 0; k < scelte.length; k++) {
          if (String(varianti[i].options[k]) !== String(scelte[k])) { ok = false; break; }
        }
        if (ok) return varianti[i];
      }
      return null;
    }

    function guarda() {
      var v = scelta();
      if (!v) return;
      var m = v.featured_media;
      if (m && m.position) vaiA(m.position - 1);
    }

    var radio = scheda.querySelectorAll('[data-km-opt]');
    for (var i = 0; i < radio.length; i++) radio[i].addEventListener('change', guarda);
  }

  function avvia() {
    var schede = document.querySelectorAll('[data-km-pdp]');
    for (var i = 0; i < schede.length; i++) aggancia(schede[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia);
  else avvia();
  document.addEventListener('shopify:section:load', avvia);
})();
